// extracted by mini-css-extract-plugin
module.exports = {"content":"main_content__3B-q5","info":"main_info__3dSTW"};